import { render, staticRenderFns } from "./MyWalletWatchOnlyDisclaimer.vue?vue&type=template&id=56a02190&scoped=true"
import script from "./MyWalletWatchOnlyDisclaimer.vue?vue&type=script&lang=ts"
export * from "./MyWalletWatchOnlyDisclaimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a02190",
  null
  
)

export default component.exports